// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { PaginationFragment } from '../../../../shared/graphql/fragments/generated/pagination.fragment.generated';
import { InvoiceCreditNoteFragment } from '../../fragments/generated/invoice-credit-note.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SearchInvoiceCreditNotePaginatedQueryVariables = Types.Exact<{
  queryInvoiceDTO: Types.QueryInvoiceDtoInput;
}>;


export type SearchInvoiceCreditNotePaginatedQueryResult = { __typename?: 'Query', searchInvoicePaginated: { __typename?: 'InvoiceListPaginatedDTO', pagination: { __typename?: 'PaginationDTO', limit: number, offset: number, total: number }, invoices: Array<{ __typename?: 'InvoiceDTO', id: number, progressive: number, block: string | null, date: LocalDate | null, documentType: Types.InvoiceDocumentTypeDto, amount: number, holder: { __typename?: 'InvoiceHolderDTO', id: number, fiscalCode: string | null, vatNumber: string | null, fullName: string, name: string | null, surname: string | null, corpName: string | null, address: string | null, city: string | null, cityId: number | null, mail: string | null, mobile: string | null, invoiceHolderType: Types.InvoiceHolderTypeDto, invoiceDocumentType: Types.InvoiceDocumentTypeDto | null } | null }> } };

export const SearchInvoiceCreditNotePaginatedGql = gql`
    query SearchInvoiceCreditNotePaginated($queryInvoiceDTO: QueryInvoiceDTOInput!) {
  searchInvoicePaginated(queryInvoiceDTO: $queryInvoiceDTO) {
    pagination {
      ...Pagination
    }
    invoices {
      ...InvoiceCreditNote
    }
  }
}
    ${PaginationFragment}
${InvoiceCreditNoteFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchInvoiceCreditNotePaginatedInjectable extends Apollo.Query<SearchInvoiceCreditNotePaginatedQueryResult, SearchInvoiceCreditNotePaginatedQueryVariables> {
    override document = SearchInvoiceCreditNotePaginatedGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */